import {get} from 'lodash'
import removeUserNameOnComment from '@/mixin/removeUserNameOnComment'
import { PM_REQUEST_TAB_ID } from '@/constants/tabs/requestsTabs'

export default {
  mixins: [removeUserNameOnComment],
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    setRequestBody (val, activeTab) {
      const { commentText, commentUsers = [], projectManager = {}, businessConsultant = {} } = val
      const pm = activeTab === PM_REQUEST_TAB_ID ? projectManager.id || projectManager._id : undefined
      const bc = activeTab === PM_REQUEST_TAB_ID ? undefined : businessConsultant.id || businessConsultant._id
      const request = {
        name: get(val, 'name', ''),
        amount: get(val, 'amount', 0),
        client: get(val, 'client.id', ''),
        dateStart: get(val, 'dateStart', ''),
        comments: get(val, 'comments', ''),
        projectManager: pm,
        businessConsultant: bc,
        dateEnd: new Date(),
        comment: {
          text: this.removeUserNameOnComment(commentText, commentUsers),
          users: commentUsers.length ? commentUsers.map((el) => el._id) : []
        },
        requestType: get(val, 'requestType', activeTab)
      }
      const status = get(val, 'status', '')
      if (status) request.status = status
      const requestId = get(val, 'id', '')
      if (requestId) request.id = requestId
      const userId = get(this.userInfo, 'id', '5f8097e4e06d0800124c7a5d')
      if (userId) request.user = userId
      const tags = get(val, 'tags', [])
      request.tags = tags.map((el) => el.id || el._id || undefined)
      return request
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/setRequestBody.js